const legalLinks = {
  personalDataConsent: 'https://mostikschool.ru/soglasiepdlk',
  privacyPolicy: 'https://mostikschool.ru/politikapdlk',
  userAgreement: 'https://mostikschool.ru/useragreement',
  telegram: 'https://t.me/mostikschoolonline',
  max: 'https://max.ru/u/f9LHodD0cOJIrBmmohc0I7QY134uqU4xvUT-wRvprgVPXf_lxLSv5AFnrio',
  maxTop: 'https://max.ru/id9718175606_biz',
  main: 'https://www.mostikschool.ru/',
  about: 'https://mostikschool.ru/aboutmostik',
  vk: 'https://vk.com/mostikschool',
  license: 'https://www.mostikschool.ru/license',
  official: 'https://www.mostikschool.ru/officialinfo',
  offer: 'https://mostikschool.ru/offercontract',
};

export default legalLinks;
